import axios from "axios";
import { Global } from '../utils/general';

const API_URL = Global.url;

class CentersCostsService {
    getCentrocosto() {
        const ruta = `${API_URL}/LP/centers-costs`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }
}

export default new CentersCostsService();